module.exports = __webpack_public_path__ + "media/images/TOEP_Logo_NewColors-40ca630db93952bfa1434b31464f518f.png";